import React from "react";
import "./VideoAndDesc.css";


function VideoAndDesc() {
  return (
    <section className="videodesc">
      <div className="info-grid">
        
        <div className="info-col">

          <p className="videoframe">
            <iframe 
              className="video"
              src="https://www.youtube.com/embed/GGrqNrVw3MI?si=DhvRcGEYBXzCZGNA" 
              title="YouTube video player" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen>
            </iframe>
          </p>
        </div>
        <div className="info-col">

          <p className="videodesc__text">
            Welcome to the Major Projects Tracker – where you can track progress towards the government’s 
            commitment to approving 150 major growth projects across the UK. Saying yes to these projects 
            means saying yes to more jobs, more opportunities, and higher living standards.
          </p>
        </div>
      </div>
    </section>
  );
}

export default VideoAndDesc;
